import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';
import { VagaFormResolver } from '../../shared/services/resolvers/vaga-resolver.service';

export const vagasRoutes: Routes = [
  {
    path: 'vagas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gestão de Vagas',
      breadcrumb: [{ label: 'Gestão de Vagas' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./vagas.component').then((m) => m.VagasComponent),
        data: {
          title: 'Manter Vagas',
          roles: [Role.VAGAS_CONSULTAR],
          breadcrumb: [{ label: 'Vagas', url: '/vagas' }],
        },
      },
      {
        path: 'cadastrar',
        data: {
          title: 'Manter Vagas',
          roles: [Role.VAGAS_CADASTRAR],
          breadcrumb: [
            { label: 'Vagas', url: '/vagas' },
            { label: 'Cadastrar', url: '/vagas/cadastrar' },
          ],
        },
        resolve: {
          domainData: VagaFormResolver,
        },
        loadComponent: () =>
          import('./vaga-form/vaga-form.component').then((m) => m.VagaFormComponent),
      },
      {
        path: 'editar/:id',
        data: {
          title: 'Manter Vagas',
          roles: [Role.VAGAS_EDITAR],
          breadcrumb: [
            { label: 'Vagas', url: '/vagas' },
            { label: 'Editar', url: '/vagas/editar' },
          ],
        },
        resolve: {
          domainData: VagaFormResolver,
        },
        loadComponent: () =>
          import('./vaga-form/vaga-form.component').then((m) => m.VagaFormComponent),
      },
      {
        path: 'detalhe/:id',
        data: {
          title: 'Manter Vagas',
          roles: [Role.VAGAS_CONSULTAR],
          breadcrumb: [
            { label: 'Vagas', url: '/vagas' },
            { label: 'Detalhe', url: '/vagas/detalhe' },
          ],
        },
        loadComponent: () =>
          import('./visualizar/vagas-visualizar.component').then(
            (m) => m.VagaDetalheComponent,
          ),
      },
    ],
  },
];
